import { HeaderScreenProps } from './header.types';
import HeaderView from './HeaderView';
import { useNavigate } from 'react-router';
import { NavigationPath } from '@/router/navigation-path.ts';

const Header = (props: HeaderScreenProps) => {
	const navigate = useNavigate();

	const handleNotificationClick = () => {};

	const handleMessageClick = () => {
		navigate(NavigationPath.notifications);
	};

	const handleAnnouncementClick = () => {
		navigate(NavigationPath.messages);
	};

	const handleProfileClick = () => {
		navigate(NavigationPath.profile);
	};

	return (
		<HeaderView
			{...props}
			onNotificationClick={handleNotificationClick}
			onMessageClick={handleMessageClick}
			onAnnouncementClick={handleAnnouncementClick}
			onProfileClick={handleProfileClick}
		/>
	);
};

export default Header;
